// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRecurringContributionResponseDto
 */
export interface IRecurringContributionResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IRecurringContributionResponseDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IRecurringContributionResponseDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IRecurringContributionResponseDto
     */
    frequency_type?: IRecurringContributionResponseDtoFrequencyTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IRecurringContributionResponseDto
     */
    recurring_day_number?: number;
    /**
     * 
     * @type {Date}
     * @memberof IRecurringContributionResponseDto
     */
    start_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IRecurringContributionResponseDto
     */
    end_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IRecurringContributionResponseDto
     */
    status?: IRecurringContributionResponseDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IRecurringContributionResponseDto
     */
    payment_method_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IRecurringContributionResponseDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IRecurringContributionResponseDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRecurringContributionResponseDto
     */
    organization_path?: string;
    /**
     * 
     * @type {Date}
     * @memberof IRecurringContributionResponseDto
     */
    next_scheduled_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IRecurringContributionResponseDto
     */
    notification_date?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IRecurringContributionResponseDtoFrequencyTypeEnum {
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    MONTHLY = 'MONTHLY'
}
/**
* @export
* @enum {string}
*/
export enum IRecurringContributionResponseDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    PAUSED = 'PAUSED',
    CANCELLED = 'CANCELLED',
    EXPIRED = 'EXPIRED'
}


/**
 * Check if a given object implements the IRecurringContributionResponseDto interface.
 */
export function instanceOfIRecurringContributionResponseDto(value: object): value is IRecurringContributionResponseDto {
    return true;
}

export function IRecurringContributionResponseDtoFromJSON(json: any): IRecurringContributionResponseDto {
    return IRecurringContributionResponseDtoFromJSONTyped(json, false);
}

export function IRecurringContributionResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRecurringContributionResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'frequency_type': json['frequency_type'] == null ? undefined : json['frequency_type'],
        'recurring_day_number': json['recurring_day_number'] == null ? undefined : json['recurring_day_number'],
        'start_date': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'end_date': json['end_date'] == null ? undefined : (new Date(json['end_date'])),
        'status': json['status'] == null ? undefined : json['status'],
        'payment_method_id': json['payment_method_id'] == null ? undefined : json['payment_method_id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'next_scheduled_date': json['next_scheduled_date'] == null ? undefined : (new Date(json['next_scheduled_date'])),
        'notification_date': json['notification_date'] == null ? undefined : (new Date(json['notification_date'])),
    };
}

export function IRecurringContributionResponseDtoToJSON(json: any): IRecurringContributionResponseDto {
    return IRecurringContributionResponseDtoToJSONTyped(json, false);
}

export function IRecurringContributionResponseDtoToJSONTyped(value?: IRecurringContributionResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'amount': value['amount'],
        'frequency_type': value['frequency_type'],
        'recurring_day_number': value['recurring_day_number'],
        'start_date': value['start_date'] == null ? undefined : ((value['start_date']).toISOString().substring(0,10)),
        'end_date': value['end_date'] == null ? undefined : ((value['end_date']).toISOString().substring(0,10)),
        'status': value['status'],
        'payment_method_id': value['payment_method_id'],
        'employee_id': value['employee_id'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'next_scheduled_date': value['next_scheduled_date'] == null ? undefined : ((value['next_scheduled_date']).toISOString().substring(0,10)),
        'notification_date': value['notification_date'] == null ? undefined : ((value['notification_date']).toISOString().substring(0,10)),
    };
}

